import { CSSProperties } from 'react';

import { TileGridTile } from './Tile';
import {
  TileGridHolder,
  TileGridTileHolder,
  tileGridDesktopTilesPerRowVar,
} from './TileGrid.styled';
import { TileGridTileData } from './TileGridTileData';
import { TileGridVariant } from './TileGridVariant';

type Props = {
  id: string;
  tiles: TileGridTileData[];
  variant: TileGridVariant;
  tilesPerRow: 3 | 4;
  onClickTile: (index: number) => void;
};

export function TileGrid({
  id,
  tiles,
  variant,
  tilesPerRow,
  onClickTile,
}: Props) {
  return (
    <TileGridHolder
      id={id}
      style={{ [tileGridDesktopTilesPerRowVar]: tilesPerRow } as CSSProperties}
    >
      {tiles.map((tile, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TileGridTileHolder key={index}>
          <TileGridTile
            id={tile.id}
            imageData={tile.imageData}
            variant={variant}
            heading={tile.heading}
            subHeading={tile.subHeading}
            onClick={() => onClickTile(index)}
          />
        </TileGridTileHolder>
      ))}
    </TileGridHolder>
  );
}
